import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import DisplayPublicFooter from '../display-public-footer';
import PageStore from '@src/components/page/store';

/**
 * 页面包裹
 * @param children
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
const Page = ({ children, store, ...rest }) => {
  store.use();
  return (
    <div {...rest}>
      {children}
      <DisplayPublicFooter />
    </div>
  );
};

export default wrapStore(Page, PageStore);
